export default class NoticeMessage {
    constructor(element) {
        this.root = element;

        this.closeButton = this.root.querySelector('.notice-message-close');
        this.closeButton.addEventListener('click', () => this.handleCloseButtonClick())

    }

    handleCloseButtonClick() {
        this.root.style.display = "none";
    }
}